import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const useApplyButtonStatus = ({
    allFiltersWithStatus,
    displayFilters,
    checkOrderCondition,
    setApplyButton,
}) => {
    useEffectWithErrorLogging(() => {
        let selectedFilters = [];
        allFiltersWithStatus.accountFilter.forEach((item) => {
            if (item.isChecked && item.name !== 'All') {
                selectedFilters.push(item.name);
            }
        });
        allFiltersWithStatus.orderStatusFilter.forEach((item) => {
            if (item.isChecked && item.description !== 'All') {
                selectedFilters.push(item.description);
            }
        });
        allFiltersWithStatus.orderTypesFilter.forEach((item) => {
            if (item.isChecked && item.orderTypeName !== 'All') {
                selectedFilters.push(item.orderTypeName);
            }
        });
        allFiltersWithStatus.physicianFilter.forEach((item) => {
            if (item.isChecked && item.name !== 'All') {
                selectedFilters.push(item.name);
            }
        });
        allFiltersWithStatus.procedureFilter.forEach((item) => {
            if (item.isChecked && item.description !== 'All') {
                selectedFilters.push(item.description);
            }
        });
        if (displayFilters.length != selectedFilters.length) {
            setApplyButton(false);
        }
        if (
            [...displayFilters].sort().join('').toLowerCase() ===
                [...selectedFilters].sort().join('').toLowerCase() &&
            !checkOrderCondition
        ) {
            setApplyButton(false);
        } else {
            setApplyButton(true);
        }
    }, [allFiltersWithStatus]);
};

export default useApplyButtonStatus;
